import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../../auth/auth.service';

@Component({
    selector: 'token',
    templateUrl: './token.component.html'
})
export class TokenComponent implements OnInit  {

  public token: string = '';

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.authService.getAccessToken().subscribe(t => this.token = t);
  }


}
